import React from 'react';
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';

const containerStyle = {
  width: '100%',
  height: '400px'
};

const DynamicMap = ({ lat, lon }) => {
  const center = {
    lat: parseFloat(lat),
    lng: parseFloat(lon)
  };

  return (
    <LoadScript googleMapsApiKey="AIzaSyDpbPE7loaRPcXz82Pgtlwi_eEBCszwFRU">
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={20}
      >
        <Marker position={center} />
      </GoogleMap>
    </LoadScript>
  );
};

export default DynamicMap;
